import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 23.58 23.58"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#fff" }, [
      _createElementVNode("path", { d: "M11.79 23.58C5.29 23.58 0 18.29 0 11.79S5.29 0 11.79 0s11.79 5.29 11.79 11.79-5.29 11.79-11.79 11.79Zm0-22.69C5.78.89.89 5.78.89 11.79s4.89 10.89 10.9 10.89 10.9-4.89 10.9-10.89S17.8.89 11.79.89Z" }),
      _createElementVNode("path", { d: "M10.06 18.64h2.76v-6.91h1.93l.21-2.32h-2.13V8.09c0-.55.11-.76.64-.76h1.49v-2.4h-1.91c-2.05 0-2.98.9-2.98 2.64v1.85H8.63v2.34h1.44v6.88Z" })
    ], -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "Facebook"}) } }